module.exports = __webpack_public_path__ + "img/TUMEN.a1a8c41d.png";